/**
 * @packageDocumentation
 * Implements the bottom HUD bar that tracks total win, bet, and balance values with responsive layout helpers.
 */
/**
 * Represents the bottom bar UI component of the game
 * @class BottomBar
 */
import * as PIXI from "pixi.js"; 
import { StartAppResize } from './../resizer';
import { BottomcanvasProperties } from "../config";
import { Balance,currencySymbol, ShowCent } from "./server";
import { applyCent, font_secondary   } from "./global";
import { SoundManager } from "./sounds";

export class BottomBar {
    /** Text display for total bet amount */
    static TotalBet:PIXI.Text;
    /** Text display for balance amount */
    static BalanceText:PIXI.Text;
    /** Text label for balance */
    static BalanceTextColon:PIXI.Text;
    /** Text label for total win */
    static TotalWinColon:PIXI.Text;
    /** Text label for total bet */
    static TotalBetColon:PIXI.Text;
    /** Callback function to show win animations */
    static showBmsAnim:(anim:string,WinValue:number)=>void;
    /** Text display for total win amount */ 
    static TotalWin:PIXI.Text;
    /** Current total win value */
    static TotalWinvalue:number = 0;
    /** Current total bet value */
    static TotalBetvalue:number = 0;
    /** Current balance value */
    static TotalBalancevalue:number = Balance;
    /** Current special win type (BIG WIN, MEGA WIN etc) */
    static currentSpecialWin = ''
    /** PIXI Application instance for bottom bar */
    public app_bottom:PIXI.Application = new PIXI.Application();

    /**
     * Creates an instance of BottomBar
     * Initializes the PIXI application and UI elements
     */
    constructor() {
        (async () => { 
        await this.app_bottom.init({ width: BottomcanvasProperties.width, height: BottomcanvasProperties.height, backgroundColor: "black",backgroundAlpha:0,resolution:2 });
          this.TotalBetfun();
          this.TotalWinFun();
          this.BalanceTextfun();

          setTimeout(() => {
            if(window.matchMedia("(orientation:portrait)").matches){
            BottomBar.AlignPortrait();
          }else{
            BottomBar.AlignLandscape();
          } 
          }, 2000);
    
          StartAppResize({ 
            app:this.app_bottom,
            app_width:BottomcanvasProperties.width,
            app_height:BottomcanvasProperties.height,
            resize_to_device:BottomcanvasProperties.resize,
            transformOrigin_Y:100,
            translate_Y:100,
            app_top:100,
            app_name:"bottom_app"
          }) 
          this.app_bottom.canvas.style.backgroundImage = "url('./assets/Images/bottomBarBG.png')";
          this.app_bottom.canvas.style.backgroundSize = "cover";
 
    })()
    }

    /**
     * Initializes balance text display elements
     */
    BalanceTextfun(){
        
        // Balance label initialization
        BottomBar.BalanceTextColon = new PIXI.Text({
            text: "BALANCE: ",
            style:new PIXI.TextStyle({
                fontFamily: font_secondary,
                dropShadow: {
                    alpha: 0.8,
                    angle: 1,
                    blur: 4,
                    color: '0x111111',
                    distance: 2,
                },
                align:"center",
                fill: '#fdd875', 
                fontSize: 40,
                fontWeight: 'bold',
            }) 
        })
       // BottomBar.BalanceTextColon.x = 100;
        //BottomBar.BalanceTextColon.y = BottomcanvasProperties.height/2; 
        BottomBar.BalanceTextColon.scale.set(1)
        BottomBar.BalanceTextColon.anchor.set(0,0.5)
        this.app_bottom.stage.addChild(BottomBar.BalanceTextColon)
 
        // Balance value initialization
        BottomBar.BalanceText = new PIXI.Text({
               text: currencySymbol+Balance.toFixed(2),
               style:new PIXI.TextStyle({
                   fontFamily: font_secondary,
                   dropShadow: {
                       alpha: 0.8,
                       angle: 1,
                       blur: 4,
                       color: '0x111111',
                       distance: 2,
                   },
                   align:"center",
                   fill: '0xffffff', 
                   fontSize: 40,
                   fontWeight: 'bold',
               }) 
           })
           //BottomBar.BalanceText.x = BottomBar.BalanceTextColon.x+BottomBar.BalanceTextColon.width;
           //BottomBar.BalanceText.y = BottomcanvasProperties.height/2; 
           BottomBar.BalanceText.scale.set(1)
           BottomBar.BalanceText.anchor.set(0,0.5)
           this.app_bottom.stage.addChild(BottomBar.BalanceText)
    }

    /**
     * Initializes total win text display elements
     */
    TotalWinFun(){
        // Total win label initialization
        BottomBar.TotalWinColon = new PIXI.Text({
            text: "TOTAL WIN:",
            style:new PIXI.TextStyle({
                fontFamily: font_secondary,
                dropShadow: {
                    alpha: 0.8,
                    angle: 1,
                    blur: 4,
                    color: '0x111111',
                    distance: 2,
                },
                align:"center",
                fill: '#fdd875', 
                fontSize: 40,
                fontWeight: 'bold',
            }) 
        })
        //BottomBar.TotalWinColon.x = (BottomcanvasProperties.width/3)*1+100;
        //BottomBar.TotalWinColon.y = BottomcanvasProperties.height/2; 
        BottomBar.TotalWinColon.scale.set(1)
        BottomBar.TotalWinColon.anchor.set(1, .5)
        this.app_bottom.stage.addChild(BottomBar.TotalWinColon)

        // Total win value initialization
        BottomBar.TotalWin = new PIXI.Text({
           text: ` ${currencySymbol}0.00`,
           style:new PIXI.TextStyle({
               fontFamily: font_secondary,
               dropShadow: {
                   alpha: 0.8,
                   angle: 1,
                   blur: 4,
                   color: '0x111111',
                   distance: 2,
               },
               align:"center",
               fill: '0xffffff', 
               fontSize: 40,
               fontWeight: 'bold',
           }) 
       })
       //BottomBar.TotalWin.x = BottomcanvasProperties.width/2
       //BottomBar.TotalWin.y = BottomcanvasProperties.height/2; 
       BottomBar.TotalWin.scale.set(1)
       BottomBar.TotalWin.anchor.set(0,0.5)
       this.app_bottom.stage.addChild(BottomBar.TotalWin)
    }

    /**
     * Initializes total bet text display elements
     */
    TotalBetfun(){
        // Total bet label initialization
        BottomBar.TotalBetColon = new PIXI.Text({
            text: "TOTAL BET: ",
            style: new PIXI.TextStyle({
                fontFamily: font_secondary,
                dropShadow: {
                    alpha: 0.8,
                    angle: 1,
                    blur: 4,
                    color: '0x111111',
                    distance: 2,
                },
                align:"center",
                fill: '#fdd875', 
                fontSize: 40,
                fontWeight: 'bold',
            }) 
        })
        //BottomBar.TotalBetColon.x = BottomcanvasProperties.width / 2 + 500 + 200;
        //BottomBar.TotalBetColon.y = BottomcanvasProperties.height / 2; 
        BottomBar.TotalBetColon.scale.set(1)
        BottomBar.TotalBetColon.anchor.set(1, 0.5)
        this.app_bottom.stage.addChild(BottomBar.TotalBetColon);


        // Total bet value initialization
        BottomBar.TotalBet = new PIXI.Text({
            text: "$10.00",
            style:new PIXI.TextStyle({
                fontFamily: font_secondary,
                dropShadow: {
                    alpha: 0.8,
                    angle: 1,
                    blur: 4,
                    color: '0x111111',
                    distance: 2,
                },
                align:"center",
                fill: '0xffffff', 
                fontSize: 40,
                fontWeight: 'bold',
            }) 
        })

        //BottomBar.TotalBet.x = BottomcanvasProperties.width / 2 + 500
        //BottomBar.TotalBet.y = BottomcanvasProperties.height/2; 
        BottomBar.TotalBet.scale.set(1)
        BottomBar.TotalBet.anchor.set(0, 0.5)
        this.app_bottom.stage.addChild(BottomBar.TotalBet)
    }

    /**
     * Updates the total bet display
     * @param value - New total bet value
     */
    static updateTotalBet(value:number){
        BottomBar.TotalBetvalue = value; 
        BottomBar.TotalBet.text = `${currencySymbol}${value.toFixed(2)}` 
        applyCent(BottomBar.TotalBet,value);  
    }

    /**
     * Updates the total win display and triggers win animations
     * @param value - New total win value
     */
    static updateTotalWin(value:number){
        let currentGameWin = (value-BottomBar.TotalWinvalue);
        BottomBar.currentSpecialWin = "WON"; 
        // if((currentGameWin)){
        //     BottomBar.showBmsAnim("big_win_anim",value);
        //     BottomBar.currentSpecialWin = "BIG WIN";
        //     SoundManager.big_win_snd.play()
        // }
        // if((currentGameWin)){
        //     BottomBar.showBmsAnim("mega_win_anim",value); 
        //     BottomBar.currentSpecialWin = "MEGA WIN"; 
        //     SoundManager.mega_win_snd.play()
        // }
        // if((currentGameWin)){
        //     BottomBar.showBmsAnim("super_win_anim",value); 
        //     BottomBar.currentSpecialWin = "SUPER WIN"; 
        //     SoundManager.super_win_snd.play()
        // }
        BottomBar.TotalWinvalue = value;
        BottomBar.TotalWin.text = ` ${currencySymbol}${value.toFixed(2)}`
        applyCent(BottomBar.TotalWin,value); 
    }

    /**
     * Updates the balance display
     * @param value - New balance value
     */
    static updateBalance(value:number){
        BottomBar.TotalBalancevalue = value; 
        BottomBar.BalanceText.text = `${currencySymbol}${value.toFixed(2)}`
        applyCent(BottomBar.BalanceText,value);
    }

    /**
     * Aligns UI elements for portrait orientation
     */
    static AlignPortrait(){ 
        BottomBar.TotalWinColon.style.fontSize = 60; 
        BottomBar.TotalWin.style.fontSize = 60;  
        BottomBar.TotalWinColon.x = BottomcanvasProperties.width / 2 + 96
        BottomBar.TotalWinColon.y = 67;
        BottomBar.TotalWin.x = BottomBar.TotalWinColon.x
        BottomBar.TotalWin.y = BottomBar.TotalWinColon.y

        BottomBar.BalanceTextColon.style.fontSize = 60; 
        BottomBar.BalanceText.style.fontSize = 60; 
        BottomBar.BalanceTextColon.x = BottomcanvasProperties.width / 2 - 600
        BottomBar.BalanceTextColon.y = BottomBar.TotalWin.y+150 
        BottomBar.BalanceText.x = BottomBar.BalanceTextColon.x+BottomBar.BalanceTextColon.width; 
        BottomBar.BalanceText.y = BottomBar.TotalWin.y+150 ;

        BottomBar.TotalBetColon.style.fontSize = 60;   
        BottomBar.TotalBet.style.fontSize = 60;  
        BottomBar.TotalBetColon.x = BottomcanvasProperties.width / 2 + 500
        BottomBar.TotalBetColon.y = BottomBar.TotalWin.y+150;
        BottomBar.TotalBet.x = BottomBar.TotalBetColon.x;
        BottomBar.TotalBet.y = BottomBar.TotalBetColon.y 
        //BottomBar.TotalWin.x = BottomBar.TotalWinColon.x+BottomBar.TotalWinColon.width
    }

    /**
     * Aligns UI elements for landscape orientation
     */
    static AlignLandscape(){ 
        BottomBar.TotalWinColon.style.fontSize = 20; 
        BottomBar.TotalWin.style.fontSize = 20;  
        BottomBar.TotalWinColon.x = BottomcanvasProperties.width/2 + 32;
        BottomBar.TotalWinColon.y = BottomcanvasProperties.height/2;
        BottomBar.TotalWin.x = BottomBar.TotalWinColon.x;
        BottomBar.TotalWin.y = BottomBar.TotalWinColon.y

        BottomBar.BalanceTextColon.style.fontSize = 20; 
        BottomBar.BalanceText.style.fontSize = 20;
        BottomBar.BalanceTextColon.x = BottomcanvasProperties.width / 2 - 500;
        BottomBar.BalanceTextColon.y = BottomcanvasProperties.height/2; 
        BottomBar.BalanceText.x = BottomBar.BalanceTextColon.x+BottomBar.BalanceTextColon.width; 
        BottomBar.BalanceText.y = BottomBar.BalanceTextColon.y

        BottomBar.TotalBetColon.x = BottomcanvasProperties.width / 2 + 450;
        BottomBar.TotalBetColon.y = BottomcanvasProperties.height/2; 
        BottomBar.TotalBetColon.style.fontSize = 20;   
        BottomBar.TotalBet.style.fontSize = 20;
        BottomBar.TotalBet.x = BottomcanvasProperties.width / 2 + 450
        BottomBar.TotalBet.y = BottomBar.TotalBetColon.y
        //BottomBar.TotalWin.x = BottomBar.TotalWinColon.x+BottomBar.TotalWinColon.width
    }
}
